import {InvoiceOrder, PurchaseOrder} from './invoice-order';
import {ServiceOrder} from './service-order';
import {Currency} from './currency';

export interface AnalyticOperation {
  id: number,
  serviceOrderId: number,
  description: string,
  class: string,
  type: string,
  isIndirect: boolean,
  amount: number,
  quantity: number,
  currencyId: number,
  repercussionId: number,
  invoiceOrderId: number,
  purchaseOrderId: number,
  isImputable: boolean
  invoiceOrder?: InvoiceOrder;
  purchaseOrder?: PurchaseOrder;
  referenceCEC?:string;
  unitPrice: number;
  serviceOrder?: ServiceOrder;

  currency?: Currency;
}

export interface AnalyticOperationCreate {
  serviceOrderId: number,
  description: string,
  class: string,
  type: string,
  isIndirect: boolean,
  currencyId: number,
  repercussionId: number,
  invoiceOrderId: number,
  purchaseOrderId: number,
  isImputable: boolean
  quantity: number,
  unitPrice: number;
}

export interface MoneyData {
  label: string;
  value: number;
  valueAlt: number;
  isPercentage: boolean;
}

export interface AnalyticOperationData {
  totalData: AnalyticOperationClassData;
  planData: AnalyticOperationClassData;
  executedData: AnalyticOperationClassData;
  engagedData: AnalyticOperationClassData;
}

export interface AnalyticOperationClassData {
  incomeTotal: number;
  expensesTotal: number;
  margin: number;
  percent: number;
}
